module.exports = __webpack_public_path__ + "img/7.d618c04b.jpg";